export default __webpack_public_path__ + "static/media/white-button-inactive.0d4856b0.png";